<template>
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
    <button
      v-for="item in items"
      :key="item.id"
      type="button"
      class="flex flex-col justify-start overflow-hidden rounded-lg bg-white text-left transition"
      :class="{
        'ring-2 ring-hazel-600 ring-offset-2 ring-offset-white': item.id === selectedId,
      }"
      @click="emit('select', item)"
    >
      <div class="aspect-video w-full overflow-hidden bg-obsidian-700">
        <img
          v-if="item.encodingStatus === 'READY' && item.posterFileUrl"
          :src="item.posterFileUrl"
          class="h-full w-full object-cover"
          alt=""
        />
        <div v-else class="flex h-full w-full items-center justify-center text-white">
          <VideoIcon class="h-10 w-10" />
        </div>
      </div>
      <div
        class="flex flex-col gap-2 p-3"
        :class="{ 'bg-hazel-50': variant === 'onWhiteBackground' }"
      >
        <div class="flex items-start justify-between gap-2">
          <div class="line-clamp-2">{{ item.title }}</div>
          <MediaEncodingStatusBadge :status="item.encodingStatus" size="sm" />
        </div>
      </div>
    </button>
  </div>
</template>

<script lang="ts" setup>
import type { Media as RosMedia } from '@carvia/ros-client-types';
import { VideoIcon } from 'lucide-vue-next';
import MediaEncodingStatusBadge from '@/components/badges/MediaEncodingStatusBadge.vue';

withDefaults(
  defineProps<{
    items: RosMedia[];
    selectedId?: string | null;
    variant?: 'default' | 'onWhiteBackground';
  }>(),
  {
    variant: 'default',
  },
);

const emit = defineEmits<{
  (e: 'select', item: RosMedia): void;
}>();
</script>
